import { defineStore } from "pinia";
import { ref } from "vue";
export const useLocalCacheStore = defineStore("localCache", () => {
  const pagination = ref(new Map<string, number>());

  function setPage(id: string, page: number) {
    pagination.value.set(id, page);
  }
  function getPage(id: string): number | undefined {
    return pagination.value.get(id);
  }

  const searchQueries = ref(new Map<string, string>());

  function setSearchQuery(id: string, query: string) {
    searchQueries.value.set(id, query);
  }

  function getSearchQuery(id: string): string {
    return searchQueries.value.get(id) ?? "";
  }

  return {
    setPage,
    getPage,
    getSearchQuery,
    setSearchQuery,
  };
});
